import {Translatable} from 'common/i18n';
import {MetricType as MetricTypes} from 'common/types/reports/bookmark';

/**
 * Template variables for labels and descriptions for the selected
 * data group
 * @example group: user|Account
 * @example groupTitle: User|Account
 * @example pluralGroup: users|Account(s)
 * @example pluralGroupTitle: Users|Account(s)
 */
export enum AggregationGroupLabel {
  Group = `group`,
  GroupTitle = `groupTitle`,
  PluralGroup = `pluralGroup`,
  PluralGroupTitle = `pluralGroupTitle`,
  MetricType = `metricType`,
  'QueryOrigin' = `queryOrigin`,
}

export enum QueryOrigin {
  Canvas = `canvas`,
  Experiment = `experiment`,
  Report = `report`,
}

export type AggregationLabelParams = Omit<
  {[key in AggregationGroupLabel]: Translatable},
  AggregationGroupLabel.MetricType | AggregationGroupLabel.QueryOrigin
> & {
  [AggregationGroupLabel.MetricType]: MetricTypes | null;
  [AggregationGroupLabel.QueryOrigin]: QueryOrigin;
};

export type SelectorTypeAggregationLabel = (params: Partial<AggregationLabelParams>) => Translatable;
